import React, { useEffect, useReducer } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import dayjs from "dayjs";
import tw from "tailwind-styled-components";
import { PrimaryText } from "@components";
import { get } from "@utiles";
import Config from "../../config";
import "dayjs/locale/fr";
import "dayjs/locale/de";

function WeatherView() {
  const utc = require("dayjs/plugin/utc");
  const timezone = require("dayjs/plugin/timezone");
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const { t } = useTranslation("common");
  const clubAddress = useSelector(
    (state) => state.courses?.clubCoursData?.attributes?.address
  );

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      players: 1,
      lat: null,
      long: null,
      weatherData: [],
    }
  );

  useEffect(() => {
    setState({
      lat: clubAddress ? clubAddress?.latitude : null,
      long: clubAddress ? clubAddress?.longitude : null,
    });
  }, [clubAddress]);

  useEffect(() => {
    // jaipur lat = 26.922070, long = 75.778885
    if (state.lat && state.long) {
      axios
        .get(
          `https://api.openweathermap.org/data/2.5/weather?lat=${state.lat}&lon=${state.long}&cnt=15&units=metric&appid=${Config.WEATHER_APPID}`
        )
        .then((response) => {
          setState({ weatherData: response?.data });
        });
    } else {
    }
  }, [state.lat, state.long]);

  var dateLanguage = "en";
  const selectLanguage = get("Language");
  if (selectLanguage !== null) {
    dateLanguage = selectLanguage === "ge" ? "de" : selectLanguage;
  } else {
    dateLanguage = "en";
  }

  return (
    <React.Fragment>
      {state.weatherData?.main && (
        <Container>
          <IconView>
            <img
              src={`https://openweathermap.org/img/w/${state.weatherData?.weather[0].icon}.png`}
              className="w-full h-full"
              alt="icon"
            />
          </IconView>
          <DateView>
            <PrimaryText className={dateTxt}>
              {dayjs
                .unix(state.weatherData?.dt)
                .locale(dateLanguage)
                .format("dddd, MMMM D, YYYY")}
            </PrimaryText>
            <PrimaryText className={temperatureTxt}>
              {state.weatherData?.main?.temp.toFixed(1) + "°"}
            </PrimaryText>
            <PrimaryText className={windTxt}>
              {t("weather.w")} {state.weatherData?.wind?.speed}{" "}
              {t("weather.mph")}
            </PrimaryText>
          </DateView>
          <SunSetView>
            <PrimaryText className={sunsetTxt}>
              {t("weather.sunrise")}
            </PrimaryText>
            <PrimaryText className={sunsetTxt}>
              {dayjs
                .unix(state.weatherData?.sys?.sunrise)
                .locale(dateLanguage)
                .format("HH:MM")}
            </PrimaryText>
            <PrimaryText className={sunsetTxt}>
              {t("weather.sunset")}
            </PrimaryText>
            <PrimaryText className={sunsetTxt}>
              {dayjs
                .unix(state.weatherData?.sys?.sunset)
                .locale(dateLanguage)
                .format("HH:MM")}
            </PrimaryText>
          </SunSetView>
        </Container>
      )}
    </React.Fragment>
  );
}

const Container = tw.div`
w-full
my-[24px]
px-[4px]
py-[25px]
rounded-lg
bg-white255b
flex
flex-row
justify-evenly
items-center
gap-x-[4px]
rounded-2xl
shadow-xl
drop-shadow-xl
overflow-hidden
h-auto
`;
const IconView = tw.div`
w-[70px] 
h-[70px]
flex
justify-center
items-end
`;
const DateView = tw.div`
w-auto 
h-auto 
flex 
flex-col 
justify-between 
items-center
`;
const dateTxt = `
text-md 
font-[Cambay]
font-semibold 
text-[15px]
text-white255 
`;
const temperatureTxt = `
text-white255 
text-4xl 
font-medium 
font-[Cambay]
`;
const windTxt = `
text-white255 
text-[15px]
font-[Cambay]
text-[0.80rem]
`;
const SunSetView = tw.div`
w-auto 
h-auto
flex 
flex-col 
justify-evenly 
items-start
gap-y-1
`;
const sunsetTxt = `
text-white255
text-[15px]
font-semibold
font-[Cambay]
`;

export default WeatherView;
